export default "__VITE_ASSET__19ca0605__"